import { Card, Modal } from "flowbite-react";
import React from "react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import Protestos from "../../common/query/Protestos";
import HistoricoConsultas from "../../common/query/HistoricoConsultas";
import AvisoCard from "../../common/query/AvisoCard";
import { EvaluationScore } from "../../common/query/EvaluationScore";
import ReactApexChart from "react-apexcharts";
import AcoesCiveis from "../../common/query/AcoesCiveis";
import ParticipacaoEmEmpresas from "../../common/query/ParticipacaoEmEmpresas";
import ChequesSustados from "../../common/query/ChequesSustados";
import ChequesSemFundos from "../../common/query/ChequesSemFundos";
import { FaRegChartBar, FaUserCheck } from "react-icons/fa";
import { IoReceiptOutline } from "react-icons/io5";
import {
  GrDocumentExcel,
  GrDocumentText,
  GrDocumentTime,
} from "react-icons/gr";
import { CiMoneyCheck1 } from "react-icons/ci";
import { MdOutlineBalance } from "react-icons/md";
import { HiOutlineCurrencyDollar, HiOutlineEye } from "react-icons/hi";
import { FiUserCheck, FiUsers } from "react-icons/fi";
import {
  formatDocument,
  getLetterScore,
  getScoreLegends,
  maskCEP,
} from "../../../utils/utils";
import CreditQuadrants from "./CreditQuadrants";
import ScoreRating from "./ScoreRating";
import StreetView from "../../common/query/StreetView";
import { LuBuilding2, LuMapPin } from "react-icons/lu";
import moment from "moment";

const NotaScale = ({ value }) => {
  const nota = String(value || "").toUpperCase();
  const notas = ["A", "B", "C", "D", "E"];
  const colors = {
    A: "bg-emerald-100 text-emerald-700 border-emerald-300",
    B: "bg-lime-100 text-lime-700 border-lime-300",
    C: "bg-amber-100 text-amber-700 border-amber-300",
    D: "bg-orange-100 text-orange-700 border-orange-300",
    E: "bg-rose-100 text-rose-700 border-rose-300",
  };

  if (!notas.includes(nota)) {
    return (
      <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-500">
        Dados insuficientes para avaliação
      </div>
    );
  }

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-3">
      <div className="mb-2 flex items-center justify-between text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-400">
        <span>Escala</span>
        <span className="rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-[10px] font-semibold text-slate-600">
          Nota {nota}
        </span>
      </div>
      <div className="grid grid-cols-5 gap-2">
        {notas.map((n) => {
          const active = n === nota;
          return (
            <div
              key={n}
              className={`flex h-10 items-center justify-center rounded-lg border text-sm font-semibold ${
                colors[n]
              } ${active ? "ring-2 ring-blue-600 shadow-sm" : "opacity-60"}`}
            >
              {n}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const AcertaEssencialPositivoQuery = ({ data, dataFull }) => {
  const [openMap, setOpenMap] = React.useState(false);

  const fullAddress = [
    data?.dadosCadastrais?.endereco,
    data?.dadosCadastrais?.numero,
    data?.dadosCadastrais?.bairro,
    data?.dadosCadastrais?.cidade,
    data?.dadosCadastrais?.cep,
  ]
    .filter(Boolean)
    .join(", ");

  const cpfValue = data?.dadosCadastrais?.cpf;
  const cpfFormatted = formatDocument(cpfValue);
  const birthMoment = data?.dadosCadastrais?.dataNascimento
    ? moment(data?.dadosCadastrais?.dataNascimento, [
        "DD/MM/YYYY",
        "YYYY-MM-DD",
      ])
    : null;
  const birthLabel = birthMoment?.isValid()
    ? birthMoment.format("DD/MM/YYYY")
    : null;
  const ageYears =
    birthMoment?.isValid() && birthMoment.isBefore(moment())
      ? moment().diff(birthMoment, "years")
      : null;
  const ageLabel =
    ageYears != null ? `${ageYears} ano${ageYears === 1 ? "" : "s"}` : null;

  return (
    <>
      <TitleStripe>
        <div className="flex items-center gap-2">
          <FiUserCheck className="text-blue-700" />{" "}
          <span>Dados Cadastrais</span>
        </div>
      </TitleStripe>

      <div className="text-xs">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
              Nome completo
            </p>
            <p className="text-lg font-semibold text-gray-900">
              {data?.dadosCadastrais?.nome || "Indisponível"}
            </p>
          </div>
          <div className="text-right">
            <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
              Situação do CPF
            </p>
            <span
              className={`inline-flex items-center rounded-full text-[11px] px-3 py-1 font-semibold ${
                data?.dadosCadastrais?.situacao?.toUpperCase() === "REGULAR"
                  ? "bg-green-100 text-green-800"
                  : "bg-red-100 text-red-800"
              }`}
            >
              {data?.dadosCadastrais?.situacao || "Indisponível"}
            </span>
          </div>
        </div>

        <div className="mt-2 flex flex-wrap gap-2 text-[10px]">
          {cpfFormatted && (
            <span className="inline-flex items-center rounded-full border border-gray-200 bg-slate-50 px-2 py-0.5 text-gray-600">
              CPF: {cpfFormatted}
            </span>
          )}
          {birthLabel && (
            <span className="inline-flex items-center rounded-full border border-gray-200 bg-slate-50 px-2 py-0.5 text-gray-600">
              Data Nasc: {birthLabel}
            </span>
          )}
          {ageLabel && (
            <span className="inline-flex items-center rounded-full border border-gray-200 bg-slate-50 px-2 py-0.5 text-gray-600">
              {ageLabel}
            </span>
          )}
        </div>

        <div className="mt-3 grid gap-2 grid-cols-2">
          {[
            {
              label: "Nome da mãe",
              value: data?.dadosCadastrais?.nomeMae || "Não Informado",
              hint: "Parente",
            },
            {
              label: "Origem CPF",
              value: data?.dadosCadastrais?.regiaoCPF || "Não Informado",
              hint: "Origem",
            },
            {
              label: "Sexo",
              value: data?.dadosCadastrais?.sexo || "Não Informado",
              hint: "Gênero",
            },
            {
              label: "Telefone",
              value: data?.dadosCadastrais?.telefone || "Não Informado",
              hint: "Contato",
            },
          ].map((item) => (
            <div
              key={item.label}
              className="rounded-xl border border-gray-200 bg-gray-50 px-3 py-2"
            >
              <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
                {item.label}
              </p>
              <p className="text-sm font-semibold text-gray-900">
                {item.value}
              </p>
              <p className="text-[10px] text-gray-500">{item.hint}</p>
            </div>
          ))}
        </div>
      </div>

      <div>
        <TitleStripe className="mb-4">
          <div className="flex items-center gap-2">
            <LuMapPin className="text-blue-700" /> <span>Localização</span>
          </div>
        </TitleStripe>
        <div className="grid gap-2 grid-cols-2">
          <div className="rounded-xl border border-gray-200 bg-white px-3 py-2">
            <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
              Endereço
            </p>
            <div className="flex items-center gap-2">
              <p className="text-[12px] font-semibold text-gray-900">
                {data?.dadosCadastrais?.endereco || "Não informado"}
              </p>
              {fullAddress && (
                <div
                  className=" flex items-center gap-1 text-[11px] text-blue-600 cursor-pointer"
                  onClick={() => setOpenMap(true)}
                >
                  <span>- Ver fotos do local</span>
                  <HiOutlineEye className="text-base" />
                </div>
              )}
            </div>
          </div>
          <div className="rounded-xl border border-gray-200 bg-white px-3 py-2">
            <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
              Bairro · CEP
            </p>
            <p className="text-[12px] font-semibold text-gray-900 flex flex-wrap gap-1">
              <span>{data?.dadosCadastrais?.bairro || "Não informado"}</span>
              <span>·</span>
              <span>{maskCEP(data?.dadosCadastrais?.cep) || "--"}</span>
            </p>
          </div>
          <div className="rounded-xl border border-gray-200 bg-white px-3 py-2">
            <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
              Cidade
            </p>
            <p className="text-[12px] font-semibold text-gray-900 flex flex-wrap gap-1">
              <span>{data?.dadosCadastrais?.cidade || "Não informado"}</span>
            </p>
          </div>
          <div className="rounded-xl border border-gray-200 bg-white px-3 py-2">
            <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
              UF
            </p>
            <p className="text-[12px] font-semibold text-gray-900 flex flex-wrap gap-1">
              <span>{data?.dadosCadastrais?.uf || "Não informado"}</span>
            </p>
          </div>
        </div>
      </div>

      <div>
        <TitleStripe className="mb-4">
          <div className="flex items-center gap-2">
            <FaRegChartBar className="text-blue-700" />{" "}
            <span>Avaliação preliminar de crédito</span>
          </div>
        </TitleStripe>
      </div>
      <EvaluationScore
        data={data}
        score={data?.score?.score}
        probability={data?.score?.probabilidade}
      />

      {dataFull?.scoreRating?.statusRetorno == 1 && (
        <ScoreRating score={dataFull?.scoreRating} block={false} />
      )}

      <div>
        <TitleStripe className="mb-4">
          <div className="flex items-center gap-2">
            <LuBuilding2 className="text-blue-700" />
            <span>Participação em empresas</span>
          </div>
        </TitleStripe>
        {data?.participacaoEmEmpresas?.length > 0 ? (
          <ParticipacaoEmEmpresas empresas={data?.participacaoEmEmpresas} />
        ) : (
          <NoOcurrence />
        )}
      </div>

      {data?.faturasEmAtraso?.nota && (
        <div>
          <TitleStripe className="mb-4">
            <div className="flex items-center gap-2">
              <IoReceiptOutline className="text-blue-700" />
              <span>Faturas em atraso</span>
            </div>
          </TitleStripe>
          <div className="-mt-2 mb-2 text-sm">
            Indica uma nota para o máximo de dias que 1 fatura ficou em atraso
            nos últimos 6 meses.
          </div>

          <NotaScale value={data?.faturasEmAtraso?.nota} />
          <div className="mt-2 text-sm">
            Quanto mais próximo o consumidor estiver da faixa{" "}
            <span className="font-semibold">A</span>, menos dias a fatura está
            ou ficou em atraso e quanto mais próximo da faixa{" "}
            <span className="font-semibold">E</span>, mais dias a fatura ficou
            em atraso.
          </div>
        </div>
      )}

      {data?.contratosRecentes?.nota && (
        <div>
          <TitleStripe className="mb-4">
            <div className="flex items-center gap-2">
              <GrDocumentText className="text-blue-700" />
              <span>Contratos recentes</span>
            </div>
          </TitleStripe>
          <div className="-mt-2 mb-2 text-sm">
            Indica uma nota para o nível de comprometimento de crédito do
            consumidor, com base na quantidade de contratos fechados nos últimos
            6 meses.
          </div>

          <NotaScale value={data?.contratosRecentes?.nota} />
          <div className="mt-2 text-sm">
            Quanto mais próximo da faixa{" "}
            <span className="font-semibold">A</span>, menos contratos foram
            fechados e quanto mais perto da faixa{" "}
            <span className="font-semibold">E</span>, mais contratos foram
            fechados nos últimos 6 meses.
          </div>
        </div>
      )}

      <div id="negativacoes-base-1">
        <TitleStripe className="mb-4">
          <div className="flex items-center gap-2">
            <HiOutlineCurrencyDollar className="text-blue-700" />
            <span>Negativações Registradas</span>
          </div>
        </TitleStripe>

        {data?.pendenciasFinanceiras?.length > 0 ? (
          <>
            <PendenciasFinanceiras
              quantidadeTotal={
                data?.resumoConsulta?.pendenciasFinanceiras?.quantidadeTotal
              }
              valorTotal={
                data?.resumoConsulta?.pendenciasFinanceiras?.valorTotal
              }
              pendenciasFinanceiras={data?.pendenciasFinanceiras}
            />
          </>
        ) : (
          <NoOcurrence />
        )}

        <div id="protestos-base-1">
          <TitleStripe className="mb-4">
            <div className="flex items-center gap-2">
              <GrDocumentExcel className="text-blue-700" />
              <span>Títulos protestados</span>
            </div>
          </TitleStripe>
          {data?.protestos?.length > 0 ? (
            <Protestos
              quantidadeTotal={data?.resumoConsulta?.protestos?.quantidadeTotal}
              valorTotal={data?.resumoConsulta?.protestos?.valorTotal}
              protestos={data?.protestos}
              temVencimento={false}
            />
          ) : (
            <NoOcurrence />
          )}
        </div>
      </div>

      <div id="ccs-base-1">
        <TitleStripe className="mb-4">
          <div className="flex items-center gap-2">
            <CiMoneyCheck1 className="text-blue-700" />
            <span>Cheques sustados</span>
          </div>
        </TitleStripe>

        {data?.chequesSustados?.length > 0 ? (
          <>
            <ChequesSustados chequesSustados={data?.chequesSustados} />
          </>
        ) : (
          <NoOcurrence />
        )}
      </div>
      <div id="ccf-base-1">
        <TitleStripe className="mb-4">
          <div className="flex items-center gap-2">
            <CiMoneyCheck1 className="text-blue-700" />
            <span>Cheques sem fundo</span>
          </div>
        </TitleStripe>

        {data?.chequesSemFundo?.length > 0 ? (
          <>
            <ChequesSemFundos chequesSemFundos={data?.chequesSemFundo} />
          </>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div id="acoes-base-1">
        <TitleStripe className="mb-4">
          <div className="flex items-center gap-2">
            <MdOutlineBalance className="text-blue-700" />
            <span>Ações Cíveis</span>
          </div>
        </TitleStripe>
        {data?.acoesCiveis?.length > 0 ? (
          <AcoesCiveis
            quantidadeTotal={data?.resumoConsulta?.acoesCiveis?.quantidadeTotal}
            acoesCiveis={data?.acoesCiveis}
          />
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-4">
          <div className="flex items-center gap-2">
            <GrDocumentTime className="text-blue-700" />
            <span>Histórico de consultas</span>
          </div>
        </TitleStripe>

        {data?.historicoConsultas?.length > 0 ? (
          <div className="flex gap-2 flex-col">
            <div className="flex-1">
              <HistoricoConsultas
                quantidadeTotal={data?.historicoConsultas?.length}
                historicoConsultas={data?.historicoConsultas}
              />
            </div>
            {/* {data?.historicoConsultasResumo?.paresMesAnoHistoricoConsultas
              ?.length > 0 && (
              <ReactApexChart
                className="border border-gray-200 rounded-md w-full mt-3"
                options={{
                  colors: ["var(--primary)"],
                  chart: {
                    height: 150,
                    type: "bar",
                    toolbar: {
                      show: false, // Remove o menu de ações
                    },
                  },
                  plotOptions: {
                    bar: {
                      borderRadius: 2,
                      dataLabels: {
                        position: "center", // top, center, bottom
                      },
                    },
                  },
                  dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                      return val;
                    },
                    offsetY: 0,
                    style: {
                      fontSize: "12px",
                      colors: ["white"],
                    },
                  },

                  xaxis: {
                    categories:
                      data?.historicoConsultasResumo
                        ?.paresMesAnoHistoricoConsultas,
                    position: "top",
                    axisBorder: {
                      show: false,
                    },
                    axisTicks: {
                      show: false,
                    },
                    crosshairs: {
                      fill: {
                        type: "gradient",
                        gradient: {
                          colorFrom: "#30ce2d",
                          colorTo: "#30ce2d",
                          stops: [0, 100],
                          opacityFrom: 0.4,
                          opacityTo: 0.5,
                        },
                      },
                    },
                    tooltip: {
                      enabled: true,
                    },
                  },
                  yaxis: {
                    axisBorder: {
                      show: false,
                    },
                    axisTicks: {
                      show: false,
                    },
                    labels: {
                      show: false,
                      formatter: function (val) {
                        return val;
                      },
                    },
                  },
                  title: {
                    text: "Últimos 90 dias",
                    floating: true,
                    offsetY: 155,
                    align: "center",
                    style: {
                      color: "#444",
                    },
                  },
                }}
                series={[
                  {
                    name: "Qtd. Consultas no período",
                    data: data?.historicoConsultasResumo
                      ?.totaisHistoricoConsultas,
                  },
                ]}
                type="bar"
                height={175}
              />
            )} */}
          </div>
        ) : (
          <NoOcurrence />
        )}
      </div>
      <Modal show={openMap} onClose={() => setOpenMap(false)} size="5xl">
        <Modal.Header>Localização</Modal.Header>
        <Modal.Body>
          <div className="space-y-2">
            <div className="text-sm text-gray-600">
              <strong>Endereço:</strong> {fullAddress || "—"}
            </div>
            {fullAddress ? (
              <StreetView address={fullAddress} height={460} />
            ) : (
              <div className="p-3 text-sm text-gray-500">
                Endereço indisponível.
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AcertaEssencialPositivoQuery;
